<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="tableColumn"
      :data="standardTagData"
      style="width: 100%;"
    >
      <template slot-scope="{ row, index }" slot="action">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            v-hasPermission="['labelManagement:tag:delete']"
            @click="delTagModalVisible = true"
            >{{ $t('alarms.common.delete') }}</Button
          >
        </span>
      </template>
    </Table>
    <br />
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
    <!-- 删除标签模式框 -->
    <Modal v-model="delTagModalVisible" width="360" :mask-closable="false">
      <p slot="header" style="color:#ff6600;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>{{ $t("alarms.common.sureDelete") }} {{ deleteName }} ?</p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="loading"
          @click="removeTag()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- 编辑标签 -->
    <Modal
      v-model="editTagModalVisible"
      :title="$t('tag.editTag')"
      @on-ok="editTagSubmit('editTagForm')"
      @on-cancel="editTagReset('editTagForm')"
      :loading="loadingEdit"
      :mask-closable="false"
      :okText="$t('alarms.common.edit')"
      :cancelText="$t('alarms.common.cancel')"
    >
      <Form
        ref="editTagForm"
        :model="editTagForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 公司 -->
        <div v-if="company == 1">
          <FormItem :label="$t('alarm_contact.companyName')" prop="companyId">
            <Select
              v-model="editTagForm.companyId"
              style="width:300px;"
              placeholder=""
            >
              <Option
                :value="item.id"
                v-for="(item, index) in companyList"
                v-bind:key="index"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </div>
        <!-- 标签 -->
        <FormItem :label="$t('tag.tagName')" prop="keyName">
          <Input v-model="editTagForm.keyName" style="width:300px" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
let tableStandardTag = {};
export default {
  name: "TableStandardTag",
  data() {
    return {
      company: getCookie(global.companyId),
      current: 1,
      dataTotal: 0,
      pageSize: 10, //分页
      isDisable: false,
      loading: false,
      loadingEdit: true,
      deleteName: "",
      delTagModalVisible: false,
      editTagModalVisible: false,
      companyList: [],
      editTagForm: {
        companyId: "",
        keyName: ""
      },
      ruleValidate: {
        companyId: [
          {
            required: true,
            message: this.$t('tag.pleaseSelectCompany'),
            trigger: "change",
            type: "number"
          }
        ],
        keyName: [
          { required: true, message: this.$t('tag.tagNameRequired'), trigger: "blur" }
        ]
      },
      tableColumn: [
        {
          title: this.$t("tag.tag"),
          key: "keyName",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.editTagModalVisible = true; //编辑
                    this.editTagForm.id = params.row.id;
                    // 公司
                    this.editTagForm.companyId = params.row.companyId;
                    // 标签
                    this.editTagForm.keyName = params.row.keyName;
                  }
                }
              },
              params.row.keyName
            );
          }
        },
        {
          title: this.$t("common.operation"),
          slot: "action",
          width: 150
        }
      ],
      standardTagData: []
    };
  },
  beforeCreate: function() {
    tableStandardTag = this;
  },
  mounted: function() {
    if (this.company == 1) {
      tableStandardTag.getCompanyDropDownBox();
    }
    tableStandardTag.getData();
  },
  methods: {
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    // 显示数据
    showAll: function() {
      tableStandardTag.getData();
    },
    // 标签查询资源
    getData: function() {
      eventBus.$on("searchKey", function(val) {
        tableStandardTag.val = val;
      });
      eventBus.$on("companyIdSearch", function(val) {
        tableStandardTag.companyIdSearch = val;
      });
      tableStandardTag.$api.tag
        .queryStandardTagsByTagKey({
          pageNum: this.current,
          pageSize: this.pageSize,
          tagKey: tableStandardTag.val,
          companyId: tableStandardTag.companyIdSearch
        })
        .then(res => {
          this.standardTagData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableStandardTag.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableStandardTag.getData();
    },
    // 销毁name
    beforeDestroy: function() {
      eventBus.$off("searchKey");
      eventBus.$off("companyIdSearch");
    },
    // 删除
    /**************************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.deleteName = this.standardTagData[index].keyName;
    },
    removeTag: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      tableStandardTag.$api.tag
        .delStandardTagById("id", this.standardTagData[lineIndex].id)
        .then(res => {
          this.loading = true;
          setTimeout(() => {
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableStandardTag.getData();
            this.isDisable = false;
            this.loading = false;
            this.delTagModalVisible = false;
            this.$Message.success(this.$t('common.deleteSuccess'));
          }, 1000);
        });
    },
    // 编辑
    /**************************************************************/
    editTagSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          const updateData = {
            id: this.editTagForm.id,
            companyId:
              this.editTagForm.companyId == null ||
              this.editTagForm.companyId == "" ||
              this.editTagForm.companyId == undefined
                ? this.company
                : this.editTagForm.companyId,
            keyName: this.editTagForm.keyName
          };
          // 编辑标签
          this.$api.tag.addStandardTag(updateData).then(res => {
            setTimeout(() => {
              tableStandardTag.getData();
              this.loadingEdit = false;
              this.$nextTick(() => {
                this.loadingEdit = true;
              });
              this.$Message.success(this.$t('common.editSuccess'));
              this.editTagModalVisible = false;
            }, 1000);
          });
        } else {
          this.loadingEdit = false;
          setTimeout(() => {
            this.loadingEdit = true;
          }, 0);
          this.$Message.error(this.$t('common.editFail'));
        }
      });
    },
    editTagReset: function(name) {
      this.editTagModalVisible = false;
      this.$refs[name].resetFields();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/configuration/label_management/tag_management/TableStandardTag.vue